import { type Static, Type } from '@sinclair/typebox';
import { FilterSchema, SwapFiltersSchema } from './common';

export const ExcelJobSchema = Type.Object({
  abortController: Type.Any(),
  createdAt: Type.Number(),
  filePath: Type.Optional(Type.String()),
  id: Type.String(),
  progress: Type.Optional(Type.Number()),
  status: Type.Union([Type.Literal('processing'), Type.Literal('completed'), Type.Literal('failed')]),
  type: Type.Literal('excelJob'),
});
export type ExcelJob = Omit<Static<typeof ExcelJobSchema>, 'abortController'> & { abortController: AbortController };

export const ExcelJobDTOSchema = Type.Omit(ExcelJobSchema, ['filePath', 'type', 'abortController']);
export type ExcelJobDTO = Static<typeof ExcelJobDTOSchema>;

// =====================================================================================================================
// Generate Excel Batch
// =====================================================================================================================

export const GenerateExcelBatchBodySchema = Type.Object({
  batchRequestKey: Type.Optional(Type.String()),
  currencySymbol: Type.String(),
  favorites: Type.Optional(Type.Array(Type.Object({ productKey: Type.String(), swapKey: Type.String() }))),
  leftFilters: Type.Object({
    productFilters: FilterSchema,
    swapFilters: FilterSchema,
  }),
  onlyPositiveSavings: Type.Optional(Type.Boolean()),
  simulatedPrice: Type.Optional(Type.Number()),
  swapFilters: SwapFiltersSchema,
  hasDateRangeChanged: Type.Boolean(),
  analysisFullUrl: Type.Optional(Type.String()),
});
export type GenerateExcelBatchBody = Static<typeof GenerateExcelBatchBodySchema>;

export const GenerateExcelBatchResponseSchema = Type.Object({
  jobId: Type.String(),
  status: Type.Literal('pending'),
});
export type GenerateExcelBatchResponse = Static<typeof GenerateExcelBatchResponseSchema>;

// =====================================================================================================================
// Download Excel
// =====================================================================================================================

export const DownloadExcelParamsSchema = Type.Object({
  jobId: Type.String(),
});
export type DownloadExcelParams = Static<typeof DownloadExcelParamsSchema>;

// =====================================================================================================================
// Abort Excel
// =====================================================================================================================

export const AbortExcelParamsSchema = Type.Object({
  jobId: Type.String(),
});
export type AbortExcelParams = Static<typeof AbortExcelParamsSchema>;
